import platformConfigJson from './config.json';

type ConfigCustomProperties = { [key: string]: any };

export type ConfigType = {
    locale: string;
    socialAuths: string[];
    toggles: { pages?: Record<string, boolean> } & {
        [key: string]: boolean;
    };
    school: {
        schoolId: number;
        domain: string;
        logo: string;
        name: string;
    };
    customProperties: ConfigCustomProperties;

    disabledWelcomeRoutes?: string[];
};

const platformConfig: Readonly<ConfigType> = platformConfigJson as unknown as Readonly<ConfigType>;

function validateConfig() {
    if (
        platformConfig.school == null ||
        !platformConfig.school.domain ||
        !platformConfig.school.logo ||
        platformConfig.school.schoolId == null ||
        !platformConfig.school.name
    ) {
        console.error(platformConfig);
        throw Error(
            "Invalid school configuration: missing one of 'school', 'domain', 'logo', 'schoolId', 'name'"
        );
    }

    if (!Array.isArray(platformConfig.socialAuths)) {
        throw Error('Invalid school configuration: socialAuths is not an array');
    }
    if (!platformConfig.socialAuths.every(e => typeof e === 'string')) {
        throw Error('Invalid school configuration: socialAuths contains non-string element');
    }
    if (typeof platformConfig.locale !== 'string') {
        throw Error('Invalid school configuration: locale is not a string');
    }
}

validateConfig();

export default class {
    static readonly rawConfig: ConfigType = platformConfig;

    static hasPage(page: string, defaultValue: boolean): boolean {
        if (
            this.rawConfig.toggles &&
            this.rawConfig.toggles.pages &&
            this.rawConfig.toggles.pages[page] !== undefined
        ) {
            return this.rawConfig.toggles.pages[page] === true;
        }
        return defaultValue;
    }
    static hasToggle(toggle: string, defaultValue: boolean): boolean {
        if (platformConfig.toggles && platformConfig.toggles[toggle] !== undefined) {
            return platformConfig.toggles[toggle] === true;
        }
        return defaultValue;
    }
}
